<div class="col-lg-12 d-flex float-start ps-4" *ngIf="areValuesCalculated">
  <div class="filter-group col-lg-1">
    <div class="filter-col-hdr Row">Contact Search</div>
    <div class="row">
      <select class="form-select col-lg-10 filter-dropdown internal"
              name="contactSearchOption"
              [(ngModel)]="contactSearchOption" style="width:83%">
        <option [ngValue]="null"></option>
        <option *ngFor="let option of searchOptions"
                [attr.selected]="option.id==contactSearchOption || null"
                [ngValue]="option.id">
          {{option.description}}
        </option>
      </select>

      <input class="form-control col-lg-10 filter-textbox contact-search"
             maxlength="100"
             type="text"
             name="contactSearchValue"
             placeholder="Contact Search"
             [(ngModel)]="contactSearchValue" (keydown.enter)="searchFilter()" />
    </div>
  </div>

  <div class="filter-group  col-md-5">
    <div class="row">
      <div class="filter-col-hdr col-lg-3">Event Search</div>
      <div class="filter-col-hdr col-lg-3">Workflow Status</div>
      <div class="filter-col-hdr col-lg-2">Work State</div>

      <div class="filter-col-hdr col-lg-2 fileterEmployeeType">Employee Type</div>
      <div class="filter-col-hdr col-lg-2 filterqueuestatus" style="padding-right: 22px;">Queue Status</div>

    </div>
    <div class="row">

      <div class="col-lg-3">
        <input class="form-control row filter-textbox internal event-search"
               maxlength="100"
               type="text"
               [(ngModel)]="queryContainer.query.eventShowName"
               placeholder="Event Name Search" (keydown.enter)="searchFilter()" />
      </div>
      <div class=" col-lg-3 filterWorkflow">
        <select class="form-select filter-dropdown internal"
                name="workflowStatus"
                [attr.disabled]="!uiValidators.isWorkflowStatusEnabled || null"
                [(ngModel)]="queryContainer.query.workflowStatus"
                (change)="changeWorkFlowStatus()">
          <option *ngFor="let option of departmentFilterValues; let index=index"
                  [value]="option.id"
                  name="department{{index}}"
                  id="department"
                  [selected]="option.id.toString() == queryContainer.query.workflowStatus">
            {{option.name}}
          </option>
        </select>
      </div>
      <div class="col-lg-2 filterWorkflow">
        <select class="form-select filter-dropdown internal"
                name="workState"
                [(ngModel)]="queryContainer.query.workState">
          <option value="">ALL</option>
          <option *ngFor="let option of workStates"
                  [ngValue]="option.id">
            {{option.description}}
          </option>
        </select>
      </div>
      <div class="col-lg-2 filterWorkflow">
        <select class="form-select filter-dropdown internal"
                name="employeeTypes"
                [(ngModel)]="queryContainer.query.employeeType">
          <option value="">ALL</option>
          <option *ngFor="let option of employeeTypes"
                  [ngValue]="option.id">
            {{option.description}}
          </option>
        </select>
      </div>
      <div class="col-lg-2 filterWorkflow">
        <select class="form-select filter-dropdown internal"
                name="queueStatus"
                [disabled]="!uiValidators.isQueueStatusEnabled"
                [(ngModel)]="queryContainer.query.queueStatus"
                (change)="validateWorkflowStatus()">
          <option value="ALL">ALL</option>
          <option *ngFor="let option of queueStatus"
                  [ngValue]="option.id"
                  [attr.selected]="option.id == queryContainer.query.queueStatus||null">
            {{option.description}}
          </option>
        </select>
      </div>

    </div>
  </div>

  <div class="filter-group  col-lg-2">
    <div class="filter-col-hdr Row">
      <div class="">WBSE or Cost Center Search</div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="filter-costcenter-type-option">
          <input type="radio"
                 name="costCenterType"
                 [(ngModel)]="costCenterType"
                 value="WBSE" />
          <span>WBSE</span>
        </div>
        <div class="filter-costcenter-type-option">
          <input type="radio"
                 name="costCenterType"
                 [(ngModel)]="costCenterType"
                 value="CC" />
          <span>CC</span>
        </div>
      </div>
      <div class="filter-wbse col-lg-8">
        <input class="form-control filter-textbox search"
               maxlength="100"
               type="text"
               placeholder="WBSE or Cost Center"
               [(ngModel)]="costCenterTypeValue" (keydown.enter)="searchFilter()"  />
      </div>
    </div>
  </div>

  <div class="filter-group dateinternal col-lg-2">
    <div class="filter-col-hdr Row">
      <div class="">Dates Worked</div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <!--<div class=" filter-col-hdr col-lg-12">Start</div>-->
        <div class="input-group date activity-datetimepicker-filter col-md-12 dateselecter">
          <div class="input-group date activity-datetimepicker-filter col-md-12 dateselecter">
            <input type="text"
                   name="filter_startDate"
                   class="form-control activity-date-focus filter-activityDate"
                   ngModel
                   bsDatepicker
                   #drp="bsDatepicker"
                   placeholder="Start Date"
                   [(ngModel)]="queryContainer.query.timecardDateFrom"
                   [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY', customTodayClass:'custom-today-class'}" />
            <div class="input-group-text">
              <i class="fa fa-calendar"></i>
            </div>
          </div>

          <div class="filter-wbse col-md-12">
            <!--<div class=" filter-col-hdr col-lg-12">End</div>-->
            <div class="input-group date activity-datetimepicker-filter col-md-12 dateselecter">
              <input type="text"
                     name="filter_endDate"
                     class="form-control activity-date-focus filter-activityDate"
                     ngModel
                     bsDatepicker
                     #drp="bsDatepicker"
                   placeholder="End Date"
                     [(ngModel)]="queryContainer.query.timecardDateTo"
                     [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY' , customTodayClass:'custom-today-class'}" (keydown.enter)="searchFilter()" />

              <span class="input-group-text">
                <i class="fa fa-calendar"></i>
              </span>
            </div>
            <span class="control-label control-label-error"
                  *ngIf="(!queryContainer.query.timecardDateFrom && queryContainer.query.timecardDateTo)">
              End Date cannot be prior to Start Date.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="buAccess.department=='PAYROLL'"
       class="filter-group processeddate-internal col-lg-1">
    <div class="filter-col-hdr">Processed Date</div>
    <div class="row">
      <div class="input-group date activity-datetimepicker-filter dateselecter">
        <input type="text"
               name="filter_ProcessDate"
               class="form-control col-lg-12 form-control activity-date-focus filter-activityDate"
               ngModel
               bsDatepicker
               placeholder="Processed Date"
               #drp="bsDatepicker"
               [disabled]="queryContainer.query.queueStatus != 'PostQueue' || null"
               [(ngModel)]="queryContainer.query.processedDate"
               [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY', customTodayClass:'custom-today-class'}" />
        <div class="input-group-text">
          <i class="fa fa-calendar"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-1">
    <div class="filter-group col-lg-12">
      <div>
        <input type="submit" value="Search" class="filterSearch filter-button-active btn btn-primary" (click)="searchFilter()" />
      </div>
      <div>
        <input type="submit" value="Reset" class="filterSearch filter-button-inactive btn btn-secondary" (click)="resetSearch()" />
      </div>     
    </div>
  </div>
</div>
